import { Section } from "@/components/common";
import { fmtDateTime } from "@/lib/format";

const KIND_DOT = { status: "bg-blue-500", time: "bg-rose-500", parts: "bg-indigo-500", problem: "bg-orange-500", approval: "bg-emerald-500", invoice: "bg-purple-500", delete: "bg-red-500", create: "bg-primary" };

export function RoTimeline({ events = [], audit = [] }) {
  const items = [
    ...events.map((e, i) => ({ id: `e-${i}-${e.at}`, at: e.at, text: e.text, who: e.user_name, kind: e.type, changes: null })),
    ...audit.filter((a) => a.action !== "update" || a.summary).map((a) => ({ id: `a-${a.id}`, at: a.at, text: a.summary || a.action, who: a.user_name, kind: a.action, changes: a.changes })),
  ].sort((a, b) => (a.at < b.at ? 1 : -1));
  return (
    <Section title="Chronologie" count={items.length} testId="ro-timeline">
      <div className="max-h-[520px] space-y-3 overflow-y-auto pr-1">
        {!items.length ? <p className="text-sm text-muted-foreground">Aucun événement enregistré.</p> : items.map((it) => (
          <div key={it.id} className="relative border-l-2 border-border pl-3 text-sm" data-testid="ro-timeline-item">
            <span className={`absolute -left-[5px] top-1.5 h-2 w-2 rounded-full ${KIND_DOT[it.kind] || "bg-muted-foreground"}`} />
            <div>{it.text}</div>
            {it.changes?.slice(0, 4).map((c) => <div key={c.field} className="text-xs text-muted-foreground">{c.field} : <span className="line-through">{String(c.old ?? "—").slice(0, 40)}</span> → {String(c.new ?? "—").slice(0, 40)}</div>)}
            <div className="text-xs text-muted-foreground">{it.who || "Système"} · {fmtDateTime(it.at)}</div>
          </div>
        ))}
      </div>
    </Section>
  );
}
